// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_as-0";
export var optionCard = "_as-1";